// extracted by mini-css-extract-plugin
export default {"image":"Image_image__S+4Xi","noImage":"Image_noImage__w98cK"};